import { IMAGES, INSTAGRAM_URL } from "@/data/assets";
import { Instagram, MoveUpRight, Lock } from "lucide-react";

export const Footer = ({ scrollTo, onEnquire }) => (
  <footer
    className="relative bg-[#0c0c0c] border-t border-white/10"
    data-testid="site-footer"
  >
    <div className="h-3 rp-checker text-white/[0.06]" />

    <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-16">
      <div className="flex flex-col md:flex-row justify-between gap-10 pb-14 border-b border-white/10">
        <div className="max-w-sm">
          <img
            src={IMAGES.logo}
            alt="Rayce Parts"
            className="h-8 w-auto mb-6"
          />
          <p className="text-white/50 text-sm leading-relaxed mb-6">
            Precision-printed, CAD-designed JDM interior parts. Custom-fit for
            your chassis — a race shop, not a print store.
          </p>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-white/70 hover:text-[#e31e24] transition-colors"
            data-testid="footer-instagram"
          >
            <Instagram size={18} /> @rayce_parts
          </a>
        </div>

        <div className="flex gap-16">
          <div>
            <span className="font-mono-rp text-[11px] tracking-[0.25em] uppercase text-white/40 mb-4 block">
              Explore
            </span>
            <ul className="space-y-3">
              {[
                ["parts", "Parts"],
                ["process", "Process"],
                ["fitment", "Fitment"],
                ["gallery", "Gallery"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    onClick={() => scrollTo(`#${id}`)}
                    className="text-white/60 hover:text-white text-sm transition-colors"
                    data-testid={`footer-link-${id}`}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <span className="font-mono-rp text-[11px] tracking-[0.25em] uppercase text-white/40 mb-4 block">
              Location
            </span>
            <p className="text-white/60 text-sm leading-relaxed">
              Based in
              <br />
              Brisbane, Australia
            </p>
            <button
              onClick={() => onEnquire("")}
              className="btn-ghost mt-6 !py-2.5 !px-4 text-xs"
              data-testid="footer-enquire-btn"
            >
              Enquire <MoveUpRight size={14} />
            </button>
          </div>
        </div>
      </div>

      <div className="pt-8 flex flex-col md:flex-row justify-between gap-4 items-start md:items-center">
        <span className="font-mono-rp text-[11px] text-white/50">
          © {new Date().getFullYear()} Rayce Parts. Preview build.
        </span>
        <div className="flex items-center gap-5">
          <a
            href="/admin"
            className="flex items-center gap-1.5 font-mono-rp text-[11px] text-white/55 hover:text-[#e31e24] transition-colors"
            data-testid="footer-admin-link"
          >
            <Lock size={11} /> Admin
          </a>
          <span className="font-mono-rp text-[11px] text-white/50">
            Precision Printed. Track Ready.
          </span>
        </div>
      </div>
    </div>
  </footer>
);
